<template>
  <div class="page">
    <section class="contact-hero">
      <div class="container contact-hero-grid">
        <div><span class="eyebrow light">START A PROJECT</span><h1>Tell us what<br><span>you need.</span></h1><p>Whether you need backup power, fire protection, security, communications or IT networking, let's discuss the facility and find the right approach.</p></div>
        <div class="contact-card"><div><span>LOCATION</span><strong>Port Harcourt, Rivers State</strong></div><div><span>EMAIL</span><strong>hello@yourcompany.com</strong></div><div><span>PHONE</span><strong>+234 000 000 0000</strong></div><div><span>WHATSAPP</span><strong>Start a conversation →</strong></div></div>
      </div>
    </section>

    <section class="section contact-form-section">
      <div class="container contact-grid">
        <div><span class="eyebrow">REQUEST A CONSULTATION</span><h2>Let's understand your project.</h2><p>Share a few details and our team can follow up with you.</p></div>
        <form class="contact-form" @submit.prevent="submitted = true">
          <label>Full name<input v-model="form.name" required type="text" placeholder="Your name"></label>
          <label>Company / Organisation<input v-model="form.company" type="text" placeholder="Company name"></label>
          <label>Phone number<input v-model="form.phone" required type="tel" placeholder="+234"></label>
          <label>Email address<input v-model="form.email" type="email" placeholder="you@company.com"></label>
          <label>What do you need?<select v-model="form.service"><option value="">Select a service</option><option>Power Backup</option><option>Fire Protection</option><option>Communication Systems</option><option>Security Systems</option><option>IT Networking</option><option>Multiple Solutions</option></select></label>
          <label>Tell us about the project<textarea v-model="form.message" rows="5" placeholder="Tell us about your facility, location and what you need..."></textarea></label>
          <button class="btn btn-red" type="submit">{{ submitted ? 'Request Received ✓' : 'Send Request →' }}</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      submitted: false,
      form: { name: '', company: '', phone: '', email: '', service: '', message: '' }
    }
  }
}
</script>